var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","height":"100%"},attrs:{"element-loading-text":"しばらくお待ちください..."}})}
var staticRenderFns = []

export { render, staticRenderFns }